<div class="availability-overview-header">
  <h1>{{ ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase }}</h1>
  <app-date-range-select
    class="date-range-select"
    [chips]="dateRangeChips"
    useQueryParam="range"
    subscribeParams
    data-cy="date-range-select"></app-date-range-select>
</div>
<div class="filter-container">
  <app-temp-work-availability-management-filter>
  </app-temp-work-availability-management-filter>
</div>
<div class="flex">
  <button
    *ngIf="!(dispoCustomer$ | async)?.disableDispoFilterSave"
    mat-button
    class="save-filter-button"
    (click)="saveDefaultFilter()"
    data-cy="save-filter-button">
    {{ ("saveDefaultFilter" | i18n) || "Filter als Standard speichern" }}
  </button>
</div>
<ng-container *ngIf="managementService.calendarRange$ | async as calendarRange">
  <ng-container
    *ngIf="
      calendarRange.from && calendarRange.to && dispoUser$ | async as dispoUser
    ">
    <app-temp-work-availabilities-user-list [loggedInUser]="dispoUser">
    </app-temp-work-availabilities-user-list>
  </ng-container>
</ng-container>

<div class="floating-actions-bar">
  <button
    class="primary-pill-button icon-left big-fab"
    (click)="createEmploymentFromAvailability()"
    type="button"
    data-cy="add-availability-button">
    <mat-icon svgIcon="add-circle-plus"></mat-icon>
    {{ ("newEmployment" | i18n) || "Neuer Einsatz" | titlecase }}
  </button>
</div>
